import styled from "styled-components";

export const BannerContainer = styled.div`
  position: relative;
  text-align: center;
  height: 400px;
  width: 100%;

  @media (min-width: 601px) and (max-width: 1023px) {
    height: 300px;
  }

  @media (max-width: 600px) {
    height: 250px;
  }
`;
